var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.722 19q-2.194 0-3.759-1.47T4.4 13.914q0-2.147 1.564-3.612 1.564-1.464 3.76-1.465h7.02l-2.782-2.782L15.014 5l4.587 4.586-4.587 4.587-1.053-1.054 2.782-2.783h-7.02q-1.566 0-2.695 1.03-1.13 1.028-1.13 2.548 0 1.518 1.13 2.552 1.128 1.035 2.694 1.034H16.9V19z"
  })));
};
export default SvgRedo;